import { useSelector } from 'react-redux';
import { projectsByPdtIdSelector } from '../projects';

const useProjectByPdtId = pdtId => {
  const projectsByPdtId = useSelector(projectsByPdtIdSelector);
  const project = projectsByPdtId[pdtId];

  return project;
};

export default useProjectByPdtId;
